export function useSegmentLabel() {
  return 'Comgate'
}
